export default __webpack_public_path__ + "static/media/info-sm.af0b5ad2.svg";